<template>
  <div class="d-flex align-center">
    <div style="width:160px">
      <date-picker
        :solo="true"
        :hide="true"
        v-model="date"
        @input="$emit('input', date)"
        label="DATE"
      ></date-picker>
    </div>
    <div class="ml-2 font-weight-medium text-uppercase">{{ day }}</div>
    <v-spacer></v-spacer>
    <v-btn class="primary" depressed tile @click="$emit('export')">
      Export PDF
    </v-btn>
  </div>
</template>

<script>
import DatePicker from "../DatePicker.vue";
import { getDateOnly, getRawDate } from "../../assets/js/common";

export default {
  props: {
    value: String
  },
  components: { DatePicker },
  data() {
    return {
      date: getDateOnly()
    };
  },
  computed: {
    day() {
      return getRawDate(this.date).format("dddd");
    }
  },
  mounted() {
    this.date = this.value;
  }
};
</script>

<style></style>
